import React from "react";
import {DataRequestDetailListCell} from "gd-react";
import {frequencyDescription, frequencyLabel, isScheduleRequest} from "../../../services/dataRequestTypes";

// A schedule has no startDate, so the shared cell would render "Invalid date - Invalid date".
class DataRequestPeriodCell extends React.Component {
    render() {
        if (!isScheduleRequest(this.props.object)) {
            return <DataRequestDetailListCell {...this.props}/>;
        }
        const label = frequencyLabel(this.props.object.type);
        return (
            <div className={"list-field data-request-detail-list-cell"}
                 style={{maxWidth: this.props.maxWidth ? this.props.maxWidth : '250px'}}>
                <div className={"data-request-row date-range"}
                     title={frequencyDescription(this.props.object.type)}>{label}</div>
            </div>
        );
    }
}

export default DataRequestPeriodCell;
